import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { SignerService } from '../../services/signer/signer.service';
import { TranslateService } from '@ngx-translate/core';
import { _tr } from '@app/extensions';

@Component({
  selector: 'app-package-error',
  templateUrl: './package-error.component.html',
  styleUrls: ['./package-error.component.scss'],
})
export class PackageErrorComponent implements OnInit, OnDestroy {
  action: string;
  errorName: string;
  errorIcon: string;

  private id;

  private subscription: any;

  public userName: any;
  public stringInfo: string;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private signerService: SignerService,
    private translate: TranslateService,
  ) {
    this.action = _tr('Envelope was deleted');
    this.errorIcon = '#dialog-decline-message';
  }

  ngOnInit() {
    const parsedData = JSON.parse(localStorage.getItem('owner-package'));

    this.userName = parsedData.email;

    this.stringInfo = 'Please, contact the envelope owner {{param1}} for more information.';

    this.subscription = this.route.params.subscribe((params) => {

      this.errorName = params.error;

      switch (this.errorName) {

        case 'PACKAGE_ARCHIVED': {
          this.action = 'This envelope has been archived and cannot be accessed.';
          this.errorIcon = '#envelope-archived';
          break;
        }

        case 'PACKAGE_TRASHED': {
          this.action = 'This envelope has been deleted and cannot be accessed.';
          this.errorIcon = '#envelope-trashed';
          break;
        }

        default: {
          this.action = params['error_description'];
          this.errorIcon = '#dialog-decline-message';
        }
      }

    });

    // this.subscription = this.route
    //    .queryParams
    //    .subscribe(params => {

    //        this.id = +params["id"];
    //    });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  close() {
    this.signerService.finish();
  }
}
